import React, { useState, useEffect, useRef } from "react";
import "stylesheets/projectResults.scss"
import { FaCheckCircle, FaLock, FaUserPlus, FaStar, FaCogs } from "react-icons/fa";
import Button from "components/button";
import { IoClose, IoWaterOutline } from "react-icons/io5";
import { HiOutlineHome } from "react-icons/hi";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuthContext } from "context/auth/AuthContext";
import { API } from "API/API";
import { toast } from "react-toastify";
import ModalC from "components/comman/ModalC";
import { ClipLoader } from 'react-spinners';
import ProductToProjectModal from "components/modal/ProductToProjectModal";
import { generateProjectPdf, generateProjectPdfBlob } from "utils/pdf";

const PIPE_SIZE_MIN_GPM = {
    "2": 15,
    "3": 35,
    "4": 50,
    "6": 100,
};

const COUNTRY_MAP = {
    US: "United States",
    CA: "Canada",
};

// Add this helper at the top of your component (near PIPE_SIZE_MIN_GPM)
const formatGPM = (value) => {
    if (value === 0) return "0.00";
    if (!value) return "0.00";
    return Number(value).toFixed(2);   // always show 2 decimal places e.g. 47.00, 6.70, 0.05
};

const STATE_MAP = {
    // US States
    AL: "Alabama", AK: "Alaska", AZ: "Arizona", AR: "Arkansas",
    CA: "California", CO: "Colorado", CT: "Connecticut", DE: "Delaware",
    DC: "District of Columbia", FL: "Florida", GA: "Georgia", GU: "Guam",
    HI: "Hawaii", ID: "Idaho", IL: "Illinois", IN: "Indiana",
    IA: "Iowa", KS: "Kansas", KY: "Kentucky", LA: "Louisiana",
    ME: "Maine", MD: "Maryland", MA: "Massachusetts", MI: "Michigan",
    MN: "Minnesota", MS: "Mississippi", MO: "Missouri", MT: "Montana",
    NE: "Nebraska", NV: "Nevada", NH: "New Hampshire", NJ: "New Jersey",
    NM: "New Mexico", NY: "New York", NC: "North Carolina", ND: "North Dakota",
    OH: "Ohio", OK: "Oklahoma", OR: "Oregon", PA: "Pennsylvania",
    PR: "Puerto Rico", RI: "Rhode Island", SC: "South Carolina", SD: "South Dakota",
    TN: "Tennessee", TX: "Texas", UT: "Utah", VT: "Vermont",
    VA: "Virginia", WA: "Washington", WV: "West Virginia", WI: "Wisconsin",
    WY: "Wyoming",
    // Canadian Provinces
    BC: "British Columbia", ON: "Ontario", NL: "Newfoundland and Labrador",
    NS: "Nova Scotia", PE: "Prince Edward Island", NB: "New Brunswick",
    QC: "Quebec", MB: "Manitoba", SK: "Saskatchewan",
    AB: "Alberta", NT: "Northwest Territories", NU: "Nunavut",
    YT: "Yukon Territory",
};

const displayCountry = (raw = "") => COUNTRY_MAP[raw?.toUpperCase()] || raw || "N/A";
const displayState = (raw = "") => STATE_MAP[raw?.toUpperCase()] || raw || "N/A";

const ProjectResults = () => {
    const [matchedProduct, setMatchedProduct] = useState(null);
    const [showSidebar, setShowSidebar] = useState(false);
    const [loading, setLoading] = useState(true);
    const [isClosing, setIsClosing] = useState(false);
    const [isGettingHelp, setIsGettingHelp] = useState(false);
    const [showCloseModal, setShowCloseModal] = useState(false);
    const [currentCalcProejct, setCurrentCalcProject] = useState(null)
    const [productDetails, setProductDetails] = useState(null);
    const [secondaryProductDetails, setSecondaryProductDetails] = useState(null);
    const [detailsLoader, setDetailsLoader] = useState(false);
    const [secDetailsLoader, setSecDetailsLoader] = useState(false);


    const [totalProductList, setTotalProductList] = useState([]);
    const [sampleProductList, setSampleProductList] = useState([]);
    const [modal, setModal] = useState(false);
    const [productId, setProductId] = useState(null);
    const [colorID, setColorID] = useState("");
    const [multipleProduct, setMultipleProduct] = useState(false);
    const [projectList, setProjectList] = useState([]);
    const [locationList, setLocationList] = useState([]);
    const [modalLoader, setModalLoader] = useState(false);
    const [pdfLoading, setPdfLoading] = useState(false);
    const [lastSelectedProject, setLastSelectedProject] = useState(null);

    const [representativeUser, setRepresentativeUser] = useState(null);
    const [pdfReady, setPdfReady] = useState(false);
    const pdfUploadedRef = useRef(false);



    const navigate = useNavigate();
    const { state } = useLocation();

    // const { token } = useAuthContext();
    const token = localStorage.getItem("mytoken") || "GUEST"


    useEffect(() => {
        // Check if we have a product ID from navigation state
        if (state?.productId) {
            getProductDetails(state.productId);
        } else {
            navigate('/createQuotationProjectForm');
        }

        if (state?.secondaryProductId) {
            getSecondaryProductDetails(state.secondaryProductId);
        }
    }, [state, navigate]);

    const handleBackToProjects = () => {
        navigate('/createQuotationProjectForm');
    };

    const handleProjectNameClick = () => {
        navigate("/createProjectForm", {
            state: {
                data: {
                    _id: state?.projectId,
                    name: currentCalcProejct?.step1?.projectName,
                    originalData: currentCalcProejct
                },
                projectId: state?.projectId,
                lastCompletedStep: 'step1',
                targetTab: 'About',
                configurationData: currentCalcProejct
            }
        });
    };

    const handleDownloadPdf = async () => {
        setPdfLoading(true);
        await generateProjectPdf(currentCalcProejct, productDetails, secondaryProductDetails, representativeUser);
        setTimeout(() => setPdfLoading(false), 1000);
    };

    const toggleSidebar = () => {
        setShowSidebar(!showSidebar);
        if (!showSidebar) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    };

    const handleCloseProject = () => {
        // Show the confirmation modal instead of directly calling API
        setShowCloseModal(true);
        setShowSidebar(false); // Close the sidebar when modal opens
    };

    const handleCloseModal = () => {
        setShowCloseModal(false);
    };

    const handleConfirmCloseProject = async () => {
        // This function will be called when user clicks "YES, CLOSE" in modal
        const configurationId = state?.projectId;
        // const productId = matchedProduct?._id || "";
        // const productName = matchedProduct?.name || "";
        const productId = productDetails?._id || "";
        const productName = productDetails?.name || "";

        if (!configurationId) {
            toast.error("Project ID not found");
            setShowCloseModal(false);
            return;
        }

        setIsClosing(true);

        try {
            const response = await API.closeCalculatorConfiguration(configurationId, token, productId,
                productName);

            if (response.success) {
                toast.success(response.message);
                setShowCloseModal(false);
                // Optionally redirect to projects list
                if (token === "GUEST") {
                    navigate('/');
                } else {
                    navigate('/createQuotationProjectForm');
                }
            } else {
                toast.error(response.message || "Failed to close project");
            }
        } catch (error) {

            toast.error("An error occurred while closing the project");
        } finally {
            setIsClosing(false);
        }
    };

    const handleGetHelp = async () => {
        // Check if we have the configuration ID
        const configurationId = state?.projectId;
        // const productId = matchedProduct?._id || "";
        // const productName = matchedProduct?.name || "";
        const productId = productDetails?._id || "";
        const productName = productDetails?.name || "";
        if (!configurationId) {
            toast.error("Project ID not found");
            return;
        }

        setIsGettingHelp(true);

        try {
            const response = await API.requestCalculatorHelp(configurationId, token, productId,
                productName);

            if (response.success) {
                toast.success(response.message);
                setShowSidebar(false);
                navigate("/contact")
            } else {
                toast.error(response.message || "Failed to submit help request");
            }
        } catch (error) {

            toast.error("An error occurred while submitting your help request");
        } finally {
            setIsGettingHelp(false);
        }
    };

    const getProductDetails = async (productId) => {
        setDetailsLoader(true);
        try {
            let response = await API.ProductDetailById(productId, token);
            if (response.success) {
                let data = response.data;
                setProductDetails(data);
                setMatchedProduct(data);
            }
        } catch (error) {
            console.error("Error fetching product details:", error);
        } finally {
            setDetailsLoader(false);
        }
    };

    const getSecondaryProductDetails = async (productId) => {
        setSecDetailsLoader(true);
        try {
            let response = await API.ProductDetailById(productId, token);
            if (response.success) {
                let data = response.data;
                setSecondaryProductDetails(data);
            }
        } catch (error) {
            console.error("Error fetching secondary product details:", error);
        } finally {
            setSecDetailsLoader(false);
        }
    };



    useEffect(() => {
        const fetchCompleteConfiguration = async () => {
            // Check if we have the configuration ID
            const configurationId = state?.projectId;

            if (!configurationId) {
                // If no ID, redirect back to projects
                navigate('/createQuotationProjectForm');
                return;
            }

            setLoading(true);

            try {
                // Call API without step parameter to get all data
                const response = await API.getCalculatorConfiguration(
                    configurationId,
                    '', // Empty string for step to get all data
                    token
                );



                if (response.success) {
                    // Set all the configuration data

                    setCurrentCalcProject(response?.data);
                    setRepresentativeUser(response?.representativeUser);



                } else {
                    toast.error(response.message || "Failed to fetch project data");
                    navigate('/createQuotationProjectForm');
                }
            } catch (error) {

                toast.error("An error occurred while loading project data");
                navigate('/createQuotationProjectForm');
            } finally {
                setLoading(false);
            }
        };

        fetchCompleteConfiguration();
    }, [state, navigate, token]);

    const getLocationList = async () => {
        try {
            let response = await API.getLocationList(token);
            setLocationList(response.data);
        } catch (error) { return error; }
    };

    const GetTableData = async () => {
        try {
            let response = await API.GetProjects(undefined, token);
            setProjectList([...response.data]);
        } catch (error) { return error; }
    };

    const handleRelatedProductSelect = (id, clrId) => {
        if (token === "GUEST") {
            toast.error("You must login first");
            return;
        }
        const param = { product: id, location: "", color: clrId };
        if (totalProductList.find((x) => x.product === id)) {
            setTotalProductList(totalProductList.filter((x) => x.product !== id));
            setSampleProductList(sampleProductList.filter((x) => x !== id));
        } else {
            setTotalProductList([...totalProductList, param]);
            setSampleProductList([...sampleProductList, id]);
        }
    };

    const onSelectSingle = (id, clrId) => {
        if (token === "GUEST") {
            toast.error("You must login first.");
            return;
        }
        if (!pdfReady) {
            toast.info("Please wait, your project report is being prepared...");
            return;
        }
        setProductId(id);
        setColorID(clrId);   // ← add this line
        setMultipleProduct(false);
        setModal(true);
    };

    const multipleProductAdd = () => {
        if (token === "GUEST") {
            toast.error("You must login first.");
            return;
        }

        if (!pdfReady) {
            toast.info("Please wait, your project report is being prepared...");
            return;
        }
        setMultipleProduct(true);
        setModal(true);
    };

    const handleModalClose = () => setModal(false);

    const onAddProduct1 = async (location, project) => {
        setModalLoader(true);
        let params;
        try {
            const configurationId = state?.projectId || undefined;
            if (multipleProduct) {
                const result = totalProductList.map((prod) => ({
                    ...prod,
                    location,
                    ...(configurationId && { configurationId })
                }));
                params = { products: result };
            } else {
                params = { products: [{ product: productId, location, color: colorID, ...(configurationId && { configurationId }) }] };
            }
            const response = await API.addproducttoproject(params, token, project);
            if (response.success) {
                setModal(false);
                setLastSelectedProject(project);
                toast.success(response.message);
                await GetTableData();
                setTotalProductList([]);
                setSampleProductList([]);
                setMultipleProduct(false);
                // navigate(`/create-project-tools/${project}`)
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            toast.error("Something went wrong");
        } finally {
            setModalLoader(false);
        }
    };

    const onAddProduct2 = async (location, name) => {
        setModalLoader(true);
        try {
            const params = { name: name.toLowerCase() };
            const response = await API.AddProjects(params, token);
            if (response.success) {
                onAddProduct1(location, response.data._id);
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            toast.error("Something went wrong");
        } finally {
            setModalLoader(false);
        }
    };
    useEffect(() => {
        if (token && token !== "GUEST") {
            getLocationList();
            GetTableData();
        }
    }, [token]);

    // Silent auto-upload: fires once when all data is ready
    useEffect(() => {
        // Wait until all required data is loaded
        if (!currentCalcProejct || !productDetails || loading || detailsLoader) return;
        if (!state?.projectId) return;

        // Only run once — never repeat
        if (pdfUploadedRef.current) return;
        pdfUploadedRef.current = true;

        const silentUpload = async () => {
            try {
                // Generate PDF as Blob silently (no popup, no download)
                const pdfBlob = await generateProjectPdfBlob(
                    currentCalcProejct,
                    productDetails,
                    secondaryProductDetails,   // can be null — that's fine
                    representativeUser         // can be null — that's fine
                );

                if (!pdfBlob) {
                    console.warn("PDF blob was null, skipping upload.");
                    return;
                }

                // Upload silently to backend — no token needed
                const response = await API.uploadCalculatorReport(
                    state.projectId,
                    pdfBlob
                );

                if (response?.status === 200) {
                    setPdfReady(true);
                    toast.success("Your project report is ready. You can now add products to your project");

                } else {
                    console.warn("PDF upload response:", response);
                }

            } catch (err) {
                // Completely silent — never show error to user
                console.error("Silent PDF upload error:", err);
            }
        };

        silentUpload();

    }, [currentCalcProejct, productDetails, loading, detailsLoader]);



    // if (loading || !matchedProduct) {
    if (loading || detailsLoader || !matchedProduct) {
        return (
            <div className="projectResults">
                <div className="container">
                    <div className="projectResults__header">
                        <button className="backBtn" onClick={handleBackToProjects}>
                            ← All Projects
                        </button>
                    </div>
                    <div className="loadingContainer">
                        <ClipLoader color="#0154A0" size={50} />
                    </div>
                </div>
            </div>
        );
    }


    return (
        <div className="projectResults">
            <div className="container">
                <div className="projectResults__header">
                    <button className="backBtn" onClick={handleBackToProjects}>
                        ← All Projects
                    </button>
                    <div className="headerRight">
                        {currentCalcProejct?.status?.toLowerCase() === "draft" && (
                            <div className="headerRight">
                                <button className="nextStepsBtn" onClick={toggleSidebar}>
                                    NEXT STEPS
                                </button>
                            </div>
                        )}
                    </div>
                </div>




                <div className="projectResults__status">
                    <div className={`statusBadge ${currentCalcProejct?.status?.toLowerCase()}`}>
                        {currentCalcProejct?.status?.toLowerCase() === "closed" && <FaLock />}
                        {currentCalcProejct?.status?.toLowerCase() === "draft" && <FaCheckCircle />}
                        {currentCalcProejct?.status?.toLowerCase() === "check" && <FaCheckCircle />}
                        {currentCalcProejct?.status}
                    </div>
                    <p>
                        {currentCalcProejct?.status?.toLowerCase() === "closed"
                            ? "Your project has been archived and is locked to further changes."
                            : currentCalcProejct?.status?.toLowerCase() === "check"
                                ? "What's next for your project?"
                                : "What's next for your project?"}
                    </p>
                </div>

                {/* Combined Project Header Box */}

                {/* Combined Project Header Box */}
                <div className="projectResults__headerBox">
                    <div className="headerBanner">
                        <div className="bannerContent">
                            <h1
                                onClick={handleProjectNameClick}
                                style={{ cursor: 'pointer' }}
                            >
                                {currentCalcProejct?.step1?.projectName || 'Project Name Here'}
                            </h1>
                            {/* <p className="addressLine">
                                {currentCalcProejct?.step1?.address?.street &&
                                    `${currentCalcProejct.step1.address.street}, `}
                                {currentCalcProejct?.step1?.address?.city &&
                                    `${currentCalcProejct.step1.address.city}, `}
                                {currentCalcProejct?.step1?.address?.state &&
                                    `${currentCalcProejct.step1.address.state} `}
                                {currentCalcProejct?.step1?.address?.zip}
                            </p> */}
                            <p className="addressLine">
                                {currentCalcProejct?.step1?.address?.street &&
                                    `${currentCalcProejct.step1.address.street}, `}
                                {currentCalcProejct?.step1?.address?.city &&
                                    `${currentCalcProejct.step1.address.city}, `}
                                {currentCalcProejct?.step1?.address?.state &&
                                    `${displayState(currentCalcProejct.step1.address.state)} `}
                                {currentCalcProejct?.step1?.address?.zip}
                            </p>
                            <p className="constructionLine">
                                {currentCalcProejct?.step1?.constructionType
                                    ?.replace(/([A-Z])/g, ' $1')
                                    .replace(/^./, str => str.toUpperCase())
                                    .trim()
                                }
                            </p>
                        </div>
                    </div>
                    <div className="bannerLogo">
                        <img src="/images/built-img.png" alt="Logo" />
                    </div>
                </div>

                <div className="projectResults__content">
                    <div className="productSection">
                        {/* Premium Grease Interceptor Section */}
                        <div className="premiumProductSection">
                            <div className="premiumProductHeader">
                                <h2>Recommended {productDetails?.manufacturerId_data[0].title.split(" ")[0]} Interceptor</h2>
                            </div>
                            <div className="premiumProductCard">
                                <div className="productImage">
                                    {productDetails?.images && productDetails.images.length > 0 ? (
                                        <img
                                            src={`${process.env.REACT_APP_IMAGE_BASEURL}${productDetails.images[0].fileName}`}
                                            alt={productDetails.name}
                                        />
                                    ) : (
                                        <div className="imagePlaceholder">
                                            <span>No Image</span>
                                        </div>
                                    )}
                                </div>
                                <div className="productInfo">
                                    <div className="titleRow">
                                        <h3>{productDetails?.name}</h3>
                                        <button
                                            className="addToProjectBtn"
                                            onClick={() =>
                                                onSelectSingle(
                                                    productDetails?._id,
                                                    productDetails?.images?.[0]?._id || ""
                                                )
                                            }
                                        >
                                            <FaUserPlus /> Add to Project
                                        </button>
                                    </div>
                                    <div className="statsRow">
                                        <div className="statItem">
                                            <div className="statIcon"><FaCogs /></div>
                                            <div className="statContent">
                                                <span className="statLabel">Model Number</span>
                                                <span className="statValue">{productDetails?.images?.[0]?.modelName || 'N/A'}</span>
                                            </div>
                                        </div>
                                        <div className="statItem">
                                            <div className="statIcon"><IoWaterOutline /></div>
                                            <div className="statContent">
                                                <span className="statLabel">Flow Rate</span>
                                                <span className="statValue">{productDetails?.scheduleTypeId_data?.[0]?.title || 'N/A'} GPM</span>
                                            </div>
                                        </div>
                                        {productDetails?.manufacturer3Id_data?.[0]?.title && productDetails.manufacturer3Id_data[0].title !== 'N/A' && (
                                            <div className="statItem">
                                                <div className="statIcon">
                                                    <img src="./images/oil-storage.png" alt="Capacity" />
                                                </div>
                                                <div className="statContent">
                                                    <span className="statLabel">Grease Capacity</span>
                                                    <span className="statValue">{productDetails.manufacturer3Id_data[0].title} lbs</span>
                                                </div>
                                            </div>
                                        )}
                                        <div className="statItem">
                                            <div className="statIcon"><HiOutlineHome /></div>
                                            <div className="statContent">
                                                <span className="statLabel">Application</span>
                                                <span className="statValue">
                                                    {productDetails?.accessibleComplaintId_data?.map(c => c.title).join(' / ')}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="detailsGrid">
                                <div className="detailCard">
                                    <h4>Why this was selected</h4>
                                    <p className="cardSubtitle">Based on your inputs:</p>
                                    <ul>
                                        <li>Total Flow Rate: {formatGPM(currentCalcProejct?.step3?.fixtures?.filter(f => f.included)?.reduce((sum, f) => sum + (parseFloat(f.flowRate) || 0), 0) || 0)} GPM</li>
                                        <li>Pipe Size: {currentCalcProejct?.step3?.drainagePipeSize || 'N/A'}"</li>
                                        <li>Installation Type: {currentCalcProejct?.step2?.greeceInterceptorLocation === 'inside' ? 'Indoors' : 'Outdoors'} {currentCalcProejct?.step2?.willBurried ? '(buried)' : '(not buried)'}</li>
                                        <li>Interceptor Type: Grease</li>
                                    </ul>
                                </div>
                                <div className="detailCard">
                                    <h4>Description</h4>
                                    <div className="productDescription">
                                        {productDetails?.description || 'No description available.'}
                                    </div>
                                </div>
                                <div className="detailCard">
                                    <h4>Ready for your Project</h4>
                                    <div className="actionButtons">
                                        {productDetails?.productFiles?.map((file, idx) => (
                                            <a
                                                key={idx}
                                                href={`${process.env.REACT_APP_IMAGE_BASEURL}${file.docFile}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="actionBtn"
                                            >
                                                {file.docName === "SPECIFICATION SHEET" ? "Download Spec Sheet" :
                                                    file.docName === "INSTALLATION GUIDE" ? "Download Installation Guide" :
                                                        file.docName}
                                            </a>
                                        ))}
                                        {/* <button className="actionBtn" onClick={handleDownloadPdf}>Email Results</button> */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Premium Solids Interceptor Section */}
                        {secondaryProductDetails && (
                            <div className="premiumProductSection" style={{ marginTop: '60px' }}>
                                <div className="premiumProductHeader">
                                    <h2>Recommended {secondaryProductDetails?.manufacturerId_data[0].title.split(" ")[0]} Interceptor</h2>
                                </div>
                                <div className="premiumProductCard">
                                    <div className="productImage">
                                        {secondaryProductDetails?.images && secondaryProductDetails.images.length > 0 ? (
                                            <img
                                                src={`${process.env.REACT_APP_IMAGE_BASEURL}${secondaryProductDetails.images[0].fileName}`}
                                                alt={secondaryProductDetails.name}
                                            />
                                        ) : (
                                            <div className="imagePlaceholder">
                                                <span>No Image</span>
                                            </div>
                                        )}
                                    </div>
                                    <div className="productInfo">
                                        <div className="titleRow">
                                            <h3>{secondaryProductDetails?.name}</h3>
                                            <button
                                                className="addToProjectBtn"
                                                onClick={() =>
                                                    onSelectSingle(
                                                        secondaryProductDetails?._id,
                                                        secondaryProductDetails?.images?.[0]?._id || ""
                                                    )
                                                }
                                            >
                                                <FaUserPlus /> Add to Project
                                            </button>
                                        </div>
                                        <div className="statsRow">
                                            <div className="statItem">
                                                <div className="statIcon"><FaCogs /></div>
                                                <div className="statContent">
                                                    <span className="statLabel">Model Number</span>
                                                    <span className="statValue">{secondaryProductDetails?.images?.[0]?.modelName || 'N/A'}</span>
                                                </div>
                                            </div>
                                            <div className="statItem">
                                                <div className="statIcon"><IoWaterOutline /></div>
                                                <div className="statContent">
                                                    <span className="statLabel">Flow Rate</span>
                                                    <span className="statValue">{secondaryProductDetails?.scheduleTypeId_data?.[0]?.title || 'N/A'} GPM</span>
                                                </div>
                                            </div>
                                            {secondaryProductDetails?.manufacturer3Id_data?.[0]?.title && secondaryProductDetails.manufacturer3Id_data[0].title !== 'N/A' && (
                                                <div className="statItem">
                                                    <div className="statIcon">
                                                        <img src="./images/oil-storage.png" alt="Capacity" />
                                                    </div>
                                                    <div className="statContent">
                                                        <span className="statLabel">Solids Capacity</span>
                                                        <span className="statValue">{secondaryProductDetails.manufacturer3Id_data[0].title}</span>
                                                    </div>
                                                </div>
                                            )}
                                            <div className="statItem">
                                                <div className="statIcon"><HiOutlineHome /></div>
                                                <div className="statContent">
                                                    <span className="statLabel">Application</span>
                                                    <span className="statValue">
                                                        {secondaryProductDetails?.accessibleComplaintId_data?.map(c => c.title).join(' / ')}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="detailsGrid">
                                    <div className="detailCard">
                                        <h4>Why this was selected</h4>
                                        <p className="cardSubtitle">Based on your inputs:</p>
                                        <ul>
                                            <li>Total Flow Rate: {formatGPM(currentCalcProejct?.step3?.fixtures?.filter(f => f.included)?.reduce((sum, f) => sum + (parseFloat(f.flowRate) || 0), 0) || 0)} GPM</li>
                                            <li>Pipe Size: {currentCalcProejct?.step3?.drainagePipeSize || 'N/A'}"</li>
                                            <li>Installation Type: {currentCalcProejct?.step2?.greeceInterceptorLocation === 'inside' ? 'Indoors' : 'Outdoors'} {currentCalcProejct?.step2?.willBurried ? '(buried)' : '(not buried)'}</li>
                                            <li>Interceptor Type: Solids</li>
                                        </ul>
                                    </div>
                                    <div className="detailCard">
                                        <h4>Description</h4>
                                        <div className="productDescription">
                                            {secondaryProductDetails?.description || 'No description available.'}
                                        </div>
                                    </div>
                                    <div className="detailCard">
                                        <h4>Ready for your Project</h4>
                                        <div className="actionButtons">
                                            {secondaryProductDetails?.productFiles?.map((file, idx) => (
                                                <a
                                                    key={idx}
                                                    href={`${process.env.REACT_APP_IMAGE_BASEURL}${file.docFile}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="actionBtn"
                                                >
                                                    {file.docName === "SPECIFICATION SHEET" ? "Download Spec Sheet" :
                                                        file.docName === "INSTALLATION GUIDE" ? "Download Installation Guide" :
                                                            file.docName}
                                                </a>
                                            ))}
                                            {/* <button className="actionBtn" onClick={() => toast.info("CAD/Revit drawings coming soon!")}>CAD/Revit Drawings</button> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="secondaryProductNote" style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f9f9f9', borderLeft: '4px solid #0056b3', borderRadius: '4px' }}>
                                    <p style={{ margin: 0, color: '#333', fontSize: '14px', lineHeight: '1.5' }}>
                                        <strong>Note:</strong> In commercial kitchens, grease interceptors can get overwhelmed when too much liquid flows through them too fast. To prevent overflow, companies install a solids interceptor before the grease interceptor — it catches solid food waste first, protecting the grease trap.
                                    </p>
                                </div>
                            </div>
                        )}




                        {productDetails?.relatedProducts && productDetails.relatedProducts.length > 0 && (
                            <div className="relatedProductsSection">
                                <div className="relatedProductsHeader">
                                    <h3>Related Products</h3>
                                    <button
                                        className="goToProjectsBtn"
                                        onClick={() => {
                                            if (token === "GUEST") {
                                                toast.error("You must login first.");
                                                return;
                                            }
                                            navigate('/projects');
                                        }}
                                    >
                                        GO TO MY PROJECTS
                                    </button>
                                </div>

                                {totalProductList.length > 0 && (
                                    <div className="noOfProduct">
                                        <p>{totalProductList.length} Selected</p>
                                        <button onClick={multipleProductAdd} className="addToProjectBtn">
                                            Add to Project
                                        </button>
                                    </div>
                                )}

                                <div className="relatedProductsGrid">
                                    {productDetails?.relatedProducts?.map((relatedProduct, index) => {
                                        const isChecked = sampleProductList?.includes(relatedProduct._id);
                                        const firstImage = relatedProduct?.images?.[0];
                                        // const firstColor = firstImage?.color || "";
                                        const firstColor = firstImage?._id || "";
                                        return (
                                            <div key={index} className="relatedProductCard">
                                                <div className="relatedProductCard__image">
                                                    <input
                                                        type="checkbox"
                                                        className="relatedProductCheckbox"
                                                        checked={isChecked}
                                                        onChange={() => handleRelatedProductSelect(relatedProduct._id, firstColor)}
                                                    />
                                                    {relatedProduct?.images && relatedProduct.images.length > 0 ? (
                                                        <img
                                                            src={`${process.env.REACT_APP_IMAGE_BASEURL}${relatedProduct?.images[0]?.fileName}`}
                                                            alt={relatedProduct.name}
                                                        />
                                                    ) : (
                                                        <div className="imagePlaceholder">
                                                            <span>No Image</span>
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="relatedProductCard__content">
                                                    <h4>{relatedProduct.name}</h4>

                                                    {/* {relatedProduct?.color_data && relatedProduct.color_data.length > 0 && (
                                                        <div className="productCard__color">
                                                            <ul>
                                                                {relatedProduct.color_data.map((colorItem, colorIndex) => (
                                                                    <li key={colorIndex}>
                                                                        {colorItem?.code2 ? (
                                                                            <div className="mainDual">
                                                                                <div style={{ backgroundColor: colorItem.code || "" }} className="colorInner"></div>
                                                                                <div style={{ backgroundColor: colorItem.code2 || "" }} className="colorInner2"></div>
                                                                            </div>
                                                                        ) : (
                                                                            <div className="main">
                                                                                <div style={{ border: "1.5px solid gray", backgroundColor: colorItem?.code }}></div>
                                                                            </div>
                                                                        )}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    )} */}

                                                    {relatedProduct?.manufacturerId_data && relatedProduct.manufacturerId_data.length > 0 && (
                                                        <h5><b>Capacity : </b>{relatedProduct.manufacturerId_data[0]?.title || 'N/A'}</h5>
                                                    )}

                                                    {relatedProduct?.images?.[0]?.modelName && (
                                                        <span className="pp"><b>Model : </b>{relatedProduct.images[0].modelName}</span>
                                                    )}

                                                    {relatedProduct.description && (
                                                        <p className="description">
                                                            {relatedProduct.description.length > 100
                                                                ? `${relatedProduct.description.substring(0, 100)}...`
                                                                : relatedProduct.description}
                                                        </p>
                                                    )}

                                                    {!isChecked && (
                                                        <button
                                                            className="relatedAddToProjectBtn"
                                                            // onClick={() => onSelectSingle(relatedProduct._id, relatedProduct?.images?.[0]?.color || "")}
                                                            onClick={() => onSelectSingle(relatedProduct._id, relatedProduct?.images?.[0]?._id || "")}

                                                        >
                                                            Add to Project
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}

                        {/* Product Documents Banner Section */}

                        {/* Fixture Information Section */}
                        {currentCalcProejct?.step3?.fixtures && currentCalcProejct.step3.fixtures.some(f => f.included) && (() => {
                            const includedFixtures = currentCalcProejct.step3.fixtures.filter(fixture => fixture.included);
                            const standardFixtures = includedFixtures.filter(f => f.fixtureType !== "custom_sink");
                            const customSinkFixtures = includedFixtures.filter(f => f.fixtureType === "custom_sink");

                            const totalFlowRate = includedFixtures.reduce((sum, f) => sum + parseFloat(f.flowRate || 0), 0).toFixed(2);

                            return (
                                <div className="fixtureSection">
                                    <h3>Fixture Information</h3>
                                    <div className="fixtureDetails">
                                        <div className="drainageInfo" style={{ marginBottom: "20px" }}>
                                            <strong>Drainage Pipe Size:</strong> {currentCalcProejct.step3.drainagePipeSize}"
                                        </div>

                                        {standardFixtures.length > 0 && (
                                            <div className="fixtureTable" style={{ marginBottom: "20px" }}>
                                                <h4 style={{ marginBottom: "10px", fontSize: "16px", color: "#fff", fontWeight: "600" }}>Standard Fixtures</h4>
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th>Fixture Name</th>
                                                            <th>Trap Size</th>
                                                            <th>DFU Type</th>
                                                            <th>DFU Value</th>
                                                            <th>Flow Rate (GPM)</th>
                                                            <th>Quantity</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {standardFixtures.map((fixture, index) => (
                                                            <tr key={index}>
                                                                <td>{fixture.fixtureName}</td>
                                                                <td>{fixture.trapSize ? `${fixture.trapSize}"` : "N/A"}</td>
                                                                <td>{fixture.dfuType || "N/A"}</td>
                                                                <td>{fixture.dfuValue || "0"}</td>
                                                                <td>{fixture.flowRate}</td>
                                                                <td>{fixture.quantity}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}

                                        {customSinkFixtures.length > 0 && (
                                            <div className="fixtureTable" style={{ marginBottom: "20px" }}>
                                                <h4 style={{ marginBottom: "10px", fontSize: "16px", color: "#fff", fontWeight: "600" }}>Custom Sink Sizing</h4>
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th>Fixture Name</th>
                                                            <th>Length (L)</th>
                                                            <th>Width (W)</th>
                                                            <th>Depth (D)</th>
                                                            <th>Compartments (N)</th>
                                                            <th>Flow Rate (GPM)</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {customSinkFixtures.map((fixture, index) => (
                                                            <tr key={index}>
                                                                <td>Custom Sink Sizing</td>
                                                                <td>{fixture.length || fixture.dimensions?.length || "N/A"}</td>
                                                                <td>{fixture.width || fixture.dimensions?.width || "N/A"}</td>
                                                                <td>{fixture.depth || fixture.dimensions?.depth || "N/A"}</td>
                                                                <td>{fixture.compartments || fixture.dimensions?.compartments || "N/A"}</td>
                                                                <td>{fixture.flowRate}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}

                                        <div className="fixtureTable">
                                            <table>
                                                <tbody>
                                                    <tr className="totalsRow">
                                                        <td style={{ textAlign: "right", paddingRight: "20px" }}>
                                                            <strong>Total Project Flow Rate:</strong>
                                                        </td>
                                                        <td style={{ width: "20%" }}>
                                                            <strong>{totalFlowRate} GPM</strong>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            );
                        })()}


                        {/* Sizing Details Section */}
                        {currentCalcProejct && (
                            <div className="sizingDetailsSection">
                                <h3>Sizing Details</h3>
                                <div className="sizingDetailsContent">
                                    {/* Step 1 - Project Information */}
                                    <div className="projectInformationColumn">
                                        <h4>Interceptor Information</h4>

                                        <div className="detailItem">
                                            <span className="label">Building Description:</span>
                                            <span className="value">
                                                {/* {currentCalcProejct.step1?.constructionType || 'N/A'} */}
                                                {currentCalcProejct?.step1?.constructionType
                                                    ?.replace(/([A-Z])/g, ' $1') // Add space before capital letters
                                                    .replace(/^./, str => str.toUpperCase()) // Capitalize first letter
                                                    .trim()
                                                }
                                            </span>
                                        </div>

                                        <div className="detailItem">
                                            <span className="label">Project Name:</span>
                                            <span className="value">{currentCalcProejct.step1?.projectName || 'N/A'}</span>
                                        </div>

                                        <div className="detailItem">
                                            <span className="label">Address:</span>
                                            <span className="value">
                                                {/* {currentCalcProejct.step1?.address?.city || ''} {currentCalcProejct.step1?.address?.state || ''} {currentCalcProejct.step1?.address?.country || ''} */}
                                                {currentCalcProejct?.step1?.address?.street &&
                                                    `${currentCalcProejct.step1.address.street}, `}
                                                {currentCalcProejct?.step1?.address?.city &&
                                                    `${currentCalcProejct.step1.address.city}, `}
                                                {currentCalcProejct?.step1?.address?.state &&
                                                    `${currentCalcProejct.step1.address.state} `}
                                                {currentCalcProejct?.step1?.address?.zip}
                                            </span>
                                        </div>

                                        <div className="detailItem">
                                            <span className="label">Authority Having Jurisdiction:</span>
                                            <span className="value">{currentCalcProejct.step1?.authorityHavingJurisdiction || 'N/A'}</span>
                                        </div>
                                        <div className="detailItem">
                                            <span className="label">Engineer Name:</span>
                                            <span className="value">{currentCalcProejct.step1?.engineerName || currentCalcProejct.step1?.representative || 'N/A'}</span>
                                        </div>
                                    </div>

                                    {/* Step 2 - Location Details */}
                                    <div className="flowRateColumn">
                                        <h4>Location Details</h4>

                                        <div className="detailItem">
                                            <span className="label">Location of Interceptor:</span>
                                            <span className="value">{currentCalcProejct.step2?.greeceInterceptorLocation || 'N/A'}</span>
                                        </div>

                                        <div className="detailItem">
                                            <span className="label">Inside Area:</span>
                                            <span className="value">{currentCalcProejct.step2?.insideArea || 'N/A'}</span>
                                        </div>

                                        <div className="detailItem">
                                            <span className="label">Is the Interceptor buried in the ground:</span>
                                            <span className="value">{currentCalcProejct.step2?.willBurried ? 'Yes' : 'No'}</span>
                                        </div>

                                        <div className="detailItem">
                                            <span className="label">Install in Vehicle Traffic Area:</span>
                                            <span className="value">{currentCalcProejct.step2?.willInstallVehichleTrafficArea ? 'Yes' : 'No'}</span>
                                        </div>

                                        <div className="detailItem">
                                            <span className="label">Install Port:</span>
                                            <span className="value">{currentCalcProejct.step2?.isInstallPort ? 'Yes' : 'No'}</span>
                                        </div>
                                        <div className="detailItem">
                                            <span className="label">Interceptor Type:</span>
                                            <span className="value">
                                                {currentCalcProejct.step2?.interceptorType
                                                    ? currentCalcProejct.step2.interceptorType
                                                        .replace(/([A-Z])/g, ' $1')
                                                        .replace(/^./, str => str.toUpperCase())
                                                        .trim()
                                                    : 'N/A'}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}







                        {/* Representative User Section */}
                        {representativeUser && (
                            <div className="representativeUserSection">
                                <h3>Representative Information</h3>
                                <div className="representativeUserContent">
                                    <div className="repUserGrid">
                                        <div className="repUserItem">
                                            <span className="label">Name:</span>
                                            <span className="value">
                                                {representativeUser.firstName} {representativeUser.lastName}
                                            </span>
                                        </div>
                                        <div className="repUserItem">
                                            <span className="label">Email:</span>
                                            <span className="value">{representativeUser.email}</span>
                                        </div>
                                        <div className="repUserItem">
                                            <span className="label">Phone:</span>
                                            <span className="value">{representativeUser.phone || 'N/A'}</span>
                                        </div>
                                        <div className="repUserItem">
                                            <span className="label">City:</span>
                                            <span className="value">{representativeUser.city || 'N/A'}</span>
                                        </div>
                                        <div className="repUserItem">
                                            <span className="label">State:</span>
                                            {/* ← Changed: now uses displayState() helper */}
                                            <span className="value">{displayState(representativeUser.state)}</span>
                                        </div>
                                        <div className="repUserItem">
                                            <span className="label">Country:</span>
                                            {/* ← Changed: now uses displayCountry() helper */}
                                            <span className="value">{displayCountry(representativeUser.country)}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Grease Output Section */}
                        {currentCalcProejct?.step4?.menu && (
                            <div className="greaseOutputSection">
                                <h3>Grease Capacity Calculation</h3>
                                <div className="greaseOutputContent">
                                    <div className="greaseInputs">
                                        <div className="inputRow">
                                            <div className="inputItem">
                                                <span className="label">Restaurant Type:</span>
                                                <span className="value">{currentCalcProejct.step4.menu || 'N/A'}</span>
                                            </div>
                                            {currentCalcProejct.step4.kitchenAppliances && currentCalcProejct.step4.kitchenAppliances.length > 0 && (
                                                <div className="inputItem">
                                                    <span className="label">In the Kitchen:</span>
                                                    <span className="value">
                                                        {currentCalcProejct.step4.kitchenAppliances
                                                            .map(app => app.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()))
                                                            .join(', ')}
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                        <div className="inputRow">
                                            {currentCalcProejct.step4.servingWare && (
                                                <div className="inputItem">
                                                    <span className="label">Kind of Dishes:</span>
                                                    <span className="value">{currentCalcProejct.step4.servingWare}</span>
                                                </div>
                                            )}
                                            {currentCalcProejct.step4.menuValue && (
                                                <div className="inputItem">
                                                    <span className="label">Menu Value:</span>
                                                    <span className="value">{currentCalcProejct.step4.menuValue}</span>
                                                </div>
                                            )}
                                        </div>
                                        <div className="inputRow">
                                            {currentCalcProejct.step4.sqfBuilding && (
                                                <div className="inputItem">
                                                    <span className="label">Square Feet of Building:</span>
                                                    <span className="value">{currentCalcProejct.step4.sqfBuilding}</span>
                                                </div>
                                            )}
                                            {currentCalcProejct.step4.diningAreaPercentage && (
                                                <div className="inputItem">
                                                    <span className="label">Dining Area Percentage:</span>
                                                    <span className="value">{currentCalcProejct.step4.diningAreaPercentage}%</span>
                                                </div>
                                            )}
                                        </div>
                                        <div className="inputRow">
                                            {currentCalcProejct.step4.sqfPerPerson && (
                                                <div className="inputItem">
                                                    <span className="label">SQF/Person:</span>
                                                    <span className="value">{currentCalcProejct.step4.sqfPerPerson}</span>
                                                </div>
                                            )}
                                            {currentCalcProejct.step4.turnsPerSeat && (
                                                <div className="inputItem">
                                                    <span className="label">Turns per Seat:</span>
                                                    <span className="value">{currentCalcProejct.step4.turnsPerSeat}</span>
                                                </div>
                                            )}
                                        </div>
                                        <div className="inputRow">
                                            {currentCalcProejct.step4.pumpOutCycle && (
                                                <div className="inputItem">
                                                    <span className="label">Pump Out Cycles:</span>
                                                    <span className="value">{currentCalcProejct.step4.pumpOutCycle} Days</span>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="greaseProductionResult">
                                        <div className="productionValue">
                                            <span className="label">Grease Production:</span>
                                            {/* <span className="value">{currentCalcProejct.step4.lbs ? `${currentCalcProejct.step4.lbs} lbs` : 'N/A'}</span> */}
                                            <span className="value">
                                                {currentCalcProejct.step4.lbs
                                                    ? `${parseFloat(currentCalcProejct.step4.lbs).toFixed(2)} lbs`
                                                    : 'N/A'}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* ── Calculations Section ─────────────────────────────── */}
                        {currentCalcProejct?.step3 && (
                            <div className="calculationsSection">
                                <h3>Calculations - ASME Sizing Guidelines</h3>

                                {/* ── Step 1: Flow Rate ──────────────────────────────── */}
                                <div className="calcBlock">
                                    <h4>Step 1: Flow Rate</h4>
                                    <p className="calcFormula">
                                        (cu in / 231) = gal × 0.75 / 2 min = 2 min flow rate
                                    </p>

                                    <div className="calcTable">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Name/Tag</th>
                                                    <th>Type</th>
                                                    <th>Dimensions</th>
                                                    <th>Qty</th>
                                                    <th>CU IN</th>
                                                    <th>Flow Rate (2 Min)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentCalcProejct.step3.fixtures
                                                    .filter(f => f.included)
                                                    .map((fixture, i) => {
                                                        const qty = parseInt(fixture.quantity) || 1;
                                                        const flowRate = parseFloat(fixture.flowRate) || 0;
                                                        const totalFlow = flowRate;
                                                        return (
                                                            <tr key={i}>
                                                                <td>{fixture.fixtureType === "custom_sink" ? "Custom Sink Sizing" : fixture.fixtureName}</td>
                                                                {/* <td>{fixture.fixtureType}</td>
                                                                 */}
                                                                <td>{fixture.fixtureType === "custom_sink" ? "Custom Sink Sizing" : (fixture.fixtureType === "other" ? "Manual Fixture Sizing" : fixture.fixtureType)}</td>
                                                                <td>
                                                                    {fixture.fixtureType === "custom_sink"
                                                                        ? (fixture.dimensions?.length && fixture.dimensions?.width && fixture.dimensions?.depth
                                                                            ? `${fixture.dimensions.length} × ${fixture.dimensions.width} × ${fixture.dimensions.depth}`
                                                                            : 'N/A')
                                                                        : (fixture.length && fixture.width && fixture.height
                                                                            ? `${fixture.length}" × ${fixture.width}" × ${fixture.height}"`
                                                                            : 'N/A')}
                                                                </td>
                                                                <td>{qty}</td>
                                                                <td>N/A</td>
                                                                <td>{formatGPM(totalFlow)} GPM</td>
                                                            </tr>
                                                        );
                                                    })}

                                                {/* Totals row */}
                                                {(() => {
                                                    const totalFlowRate = currentCalcProejct.step3.fixtures
                                                        .filter(f => f.included)
                                                        .reduce((sum, f) => sum + (parseFloat(f.flowRate) || 0), 0);
                                                    return (
                                                        <tr className="calcTotalRow">
                                                            <td colSpan={5}><strong>Total</strong></td>
                                                            <td><strong>{formatGPM(totalFlowRate)} GPM</strong></td>
                                                        </tr>
                                                    );
                                                })()}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Pipe size minimum note */}
                                    {(() => {
                                        const pipeSize = String(currentCalcProejct.step3.drainagePipeSize);
                                        const PIPE_SIZE_MIN_GPM = { "2": 15, "3": 35, "4": 50, "6": 100 };
                                        const minGpm = PIPE_SIZE_MIN_GPM[pipeSize];
                                        const totalFlowRate = currentCalcProejct.step3.fixtures
                                            .filter(f => f.included)
                                            .reduce((sum, f) => sum + (parseFloat(f.flowRate) || 0), 0);
                                        const usedGpm = minGpm ? Math.max(totalFlowRate, minGpm) : totalFlowRate;

                                        return minGpm ? (
                                            <div className="pipeSizeNote">
                                                <strong>
                                                    Pipe size ({pipeSize} in) flow rate minimum used to size interceptor: {productDetails?.scheduleTypeId_data?.[0]?.title || 'N/A'} GPM
                                                </strong>
                                                {/* <p>Minimum flow rate for pipe size per Table 3 of MARIA Manual</p> */}
                                            </div>
                                        ) : null;
                                    })()}
                                </div>

                                {/* ── Step 2: Grease Production (only if step4 exists) ── */}
                                {currentCalcProejct?.step4?.menu && (
                                    <div className="calcBlock">
                                        <h4>Step 2: Grease Production</h4>
                                        <p className="calcFormula">
                                            Servings per day × Grease production value × Days between pump-outs = Grease output
                                        </p>

                                        <div className="calcTable">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>Name</th>
                                                        <th>Qty</th>
                                                        <th>Turns</th>
                                                        <th>MPD</th>
                                                        <th>Grease Production</th>
                                                        <th>Pumpout</th>
                                                        <th>Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {(() => {
                                                        const step4 = currentCalcProejct.step4;
                                                        const menuValue = step4.menuValue || 0;
                                                        const pumpOut = step4.pumpOutCycle ? parseInt(step4.pumpOutCycle) : 90;
                                                        const turns = step4.turnsPerSeat ? parseInt(step4.turnsPerSeat) : 1;

                                                        const lbsPerMeal = menuValue > 0
                                                            ? parseFloat(step4.lbs) / (menuValue * pumpOut)
                                                            : 0;
                                                        const flatwareLabel = step4.servingWare?.toLowerCase().includes('silver') || step4.servingWare?.toLowerCase().includes('flatware')
                                                            ? 'flatware'
                                                            : 'no flatware';
                                                        const menuType = step4.menu || '';
                                                        const greaseLabel = `${lbsPerMeal.toFixed(4)} (${menuType.toLowerCase()}/${flatwareLabel})`;

                                                        return (
                                                            <tr>
                                                                <td>{menuType}</td>
                                                                <td>1</td>
                                                                <td>× {turns}</td>
                                                                <td>{menuValue}</td>
                                                                <td>{greaseLabel}</td>
                                                                <td>{pumpOut}</td>
                                                                <td>{parseFloat(step4.lbs).toFixed(2)} lbs</td>
                                                            </tr>
                                                        );
                                                    })()}

                                                    <tr className="calcTotalRow">
                                                        <td colSpan={6}><strong>Total</strong></td>
                                                        <td>
                                                            <strong>
                                                                {parseFloat(currentCalcProejct.step4.lbs).toFixed(2)} lbs
                                                            </strong>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* ── Product Summary Box (like PDF bottom box) ── */}
                        {productDetails && (
                            <div className="calcProductBox">
                                <div className="calcProductModel">
                                    <div className="modelLabel">MIFAB Model</div>
                                    <div className="modelNumber">
                                        {productDetails?.images?.[0]?.modelName || "N/A"}
                                    </div>
                                </div>
                                <div className="calcProductDesc">
                                    {productDetails?.description && (
                                        <div><strong>Description:</strong> {productDetails.description}</div>
                                    )}
                                    {(productDetails?.length && productDetails?.width && productDetails?.height) && (
                                        <div>
                                            <strong>Dimensions:</strong> Length: {productDetails.length}", Width: {productDetails.width}", Height: {productDetails.height}"
                                        </div>
                                    )}
                                    <div>
                                        <strong>Flow Rate:</strong> {productDetails?.scheduleTypeId_data?.[0]?.title || "N/A"} GPM
                                    </div>
                                    {productDetails?.manufacturer3Id_data?.[0]?.title && productDetails.manufacturer3Id_data[0].title !== "N/A" && (
                                        <div>
                                            <strong>Grease Capacity:</strong> {productDetails.manufacturer3Id_data[0].title} lbs
                                        </div>
                                    )}
                                    <button
                                        onClick={() => navigate(`/product-detail/${productDetails?._id}`)}
                                        style={{
                                            backgroundColor: "#0154A0",
                                            color: "#fff",
                                            border: "none",
                                            padding: "6px 16px",
                                            borderRadius: "4px",
                                            fontWeight: "600",
                                            fontSize: "13px",
                                            cursor: "pointer",
                                            whiteSpace: "nowrap"
                                        }}
                                        onMouseEnter={(e) => e.target.style.backgroundColor = "#014380"}
                                        onMouseLeave={(e) => e.target.style.backgroundColor = "#0154A0"}
                                    >
                                        View Detail
                                    </button>

                                    {productDetails?.manufacturer4Id_data?.[0]?.title && (
                                        <div>
                                            <strong>Liquid Capacity:</strong> {productDetails.manufacturer4Id_data[0].title} gal
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* ── Footer note ── */}
                        <p className="calcFooterNote">
                            Consult plumbing schedule for solids interceptor and sampling port details.
                        </p>

                    </div>
                </div>

                {/* Sidebar */}
                <div className={`projectSidebar ${showSidebar ? "show" : ""}`}>
                    <div className="projectSidebar__header">
                        <h4>Next steps ?</h4>
                        <button type="button" onClick={toggleSidebar}>
                            <IoClose />
                        </button>
                    </div>
                    <div className="projectSidebar__body">
                        <div
                            className={`sidebarOption`}
                            onClick={handleCloseProject}
                        >
                            <div className="optionIcon close">
                                <span>✖️</span>
                            </div>
                            <div className="optionContent">
                                <h5>Sizing Completed</h5>
                                <p>Save for future use</p>
                            </div>
                        </div>

                        <div
                            className={`sidebarOption ${isGettingHelp ? 'disabled' : ''}`}
                            onClick={isGettingHelp ? null : handleGetHelp}
                        >
                            <div className="optionIcon help">
                                <span>{isGettingHelp ? '⏳' : '🔧'}</span>
                            </div>
                            <div className="optionContent">
                                <h5>{isGettingHelp ? 'Submitting Request...' : 'Ask MIFAB for help'}</h5>
                                <p>Contact MIFAB for assistance with your project's approval.</p>
                            </div>
                        </div>
                        <div
                            className={`sidebarOption ${pdfLoading ? 'disabled' : ''}`}
                            onClick={pdfLoading ? null : handleDownloadPdf}
                        >
                            <div className="optionIcon pdf">
                                <span>{pdfLoading ? '⏳' : '📄'}</span>
                            </div>
                            <div className="optionContent">
                                <h5>{pdfLoading ? 'Generating PDF...' : 'Download PDF Report'}</h5>
                                <p>Save a full summary of this project including product specs and sizing details.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Close Project Confirmation Modal */}
            {showCloseModal && (
                <ModalC
                    message="Are you sure you'd like to close the project? You will no longer be able to edit the project after it is closed."
                    title="Close Project?"
                    showmodal={true}
                    handleClose={handleCloseModal}
                    deleteLoader={isClosing}
                    handleYes={handleConfirmCloseProject}
                />
            )}
            <ProductToProjectModal
                list={locationList}
                clickProject={handleModalClose}
                show={modal}
                list1={projectList}
                defaultProjectId={lastSelectedProject}
                loader={modalLoader}
                onAddProduct1={onAddProduct1}
                onAddProduct2={onAddProduct2}
            />
        </div>
    );
};

export default ProjectResults;